import { Redirect } from 'react-router-dom'

const HeardFromSurvey = () => {
  return <Redirect to="/heard-from-survey" />
}

export default HeardFromSurvey
